<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <div />
</template>

<script>
export default {
  name: 'GlobalListener',
  data: function () {
    return {
      keyCode: ''
    }
  },
  mounted () {
    window.onkeydown = async (event) => {
      if (event.keyCode !== 13) {
        if (event.key.length < 2) {
          this.keyCode += event.key
        }
      } else {
        this.$emit('submit', this.keyCode)
        this.keyCode = ''
      }
    }
  },
  destroyed () {
    window.onkeydown = null
  }
}
</script>

<style scoped>

</style>
